module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/faq-view/faq-view.component.scss
// module id = ./src/app/+app-custom/views/faq-view/faq-view.component.scss
// module chunks = main